var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#F2F2F2",
    stroke: "#ABABAB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2698_37042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3273 9.99914H10.0045V12.669H11.3273V9.99914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9792 11.328H12.6564V12.669H13.9792V11.328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6742 15.3299V12.669H17.9976V11.328H16.6742V10.0109H17.9976V8.66988H16.6742V7.31962H13.9904V6H10.0045V7.31962H7.32283V9.99914H6V12.669H7.32283V15.3299H6V17.9998H10.0045V16.6725H11.3359V17.9998H13.9916V16.6725H16.6725V17.9998H18.0002V15.3299H16.6742ZM9.93334 15.3299H8.64588V8.66217H15.3511V15.3299H9.93334Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2698_37042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPin);
export default __webpack_public_path__ + "static/media/ico-pin.945068853bc293c7d2f10973daecf8bb.svg";
export { ForwardRef as ReactComponent };